import network from '@/utils/network'
import store from '@/store'

/**
 * Créé un compte utilisateur
 * @returns {Promise<>}
 */
export const postUser = async (user) => {
  const r = await network.post(`user`, { user })
  return r.data
}

/**
 * Demande une reinitialisation du mot de passe
 * @returns {Promise<>}
 */
export const postUserForgot = async (user) => {
  const r = await network.post(`user/forgot-password`, user)
  return r.data
}

/**
 * Reinitialisation du mot de passe
 * @returns {Promise<>}
 */
export const putUserForgot = async ({ confirmationToken, ...user }) => {
  const r = await network.put(`user/forgot-password/${confirmationToken}`, user)
  return r.data
}

/**
 * Met à jour l'utilisateur
 * @returns {Promise<>}
 */
export const putUser = async (user) => {
  const r = await network.put(`user`, user)
  return r.data
}

/**
 * Récupère les infos du dashboard
 * @returns {Promise<>}
 */
export const getUserDashboard = async () => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`user/dashboard/${slugAgency}`)
  return r.data
}
